import type { AutoLayout, Direction } from '@lighthouse/core'
import { DIRECTION } from '@lighthouse/core'

import { getFontSizeByPageStyle } from '../../../utils/layout'
import type { Rect } from '../types'

export function transformPadding2px(padding: AutoLayout['padding'], rect: Rect): [number, number, number, number] {
    const [pl = 0, pt = 0, pr = 0, pb = 0] = padding?.size ?? []
    const unit = padding?.unit || 'px'

    if (unit === '%') {
        const plPx = (pl / 100) * rect.width
        const ptPx = (pt / 100) * rect.height
        const prPx = (pr / 100) * rect.width
        const pbPx = (pb / 100) * rect.height
        return [plPx, ptPx, prPx, pbPx]
    }

    if (unit === 'rem') {
        const fontSize = getFontSizeByPageStyle() || 0
        const plPx = pl * fontSize
        const ptPx = pt * fontSize
        const prPx = pr * fontSize
        const pbPx = pb * fontSize
        return [plPx, ptPx, prPx, pbPx]
    }

    return [pl, pt, pr, pb]
}

export function transformGap2px(gap: AutoLayout['gap'], rect: Rect, direction: Direction, padding: [number, number, number, number]) {
    const unit = gap?.unit || 'px'
    const size = gap?.size || 0

    if (unit === '%') {
        const isHorizontal = direction === DIRECTION.horizontal
        const [pl, pt, pr, pb] = padding
        return ((rect[isHorizontal ? 'width' : 'height'] - (isHorizontal ? pl + pr : pt + pb)) * size) / 100
    }

    if (unit === 'rem') {
        const fontSize = getFontSizeByPageStyle() || 0
        return fontSize * size
    }

    return size
}
